import React from 'react';

const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const COUNTRY_CODE = process.env.COUNTRY_CODE || '';
  const MARKET = process.env.MARKET || '';
  let theme = COUNTRY_CODE === 'FI' ? COUNTRY_CODE.toLowerCase() : 'default';
  if (MARKET) {
    theme = MARKET.toLowerCase();
  }
  return (
    <div data-testid="theme" className={`theme-${theme} theme`}>
      {children}
    </div>
  );
};
export default ThemeProvider;
